/* eslint-disable import/prefer-default-export */
import { setCookie, setTokenInCookies } from '../../hooks/useCookie';
import { setLocalStorageWithPrefix } from '../../hooks/useLocalStorage';
import { getLoginOperation } from '../../integration/getBrands.api';

export const getLoginData = async ({
  graphql,
  emailAddress,
  userPassword,
  recaptchaV3Token,
  setInvalidText,
  captchaV2,
  captchaV2Error,
  setCaptchaV2Error,
  setDisablecta,
  recaptchaRef,
}) => {
  try {
    const brand = 'ION';
    const password = userPassword;
    const data = await getLoginOperation({
      graphql,
      variables: {
        email: emailAddress,
        password,
        recaptchaToken: captchaV2 || recaptchaV3Token,
        recaptchaVersion: captchaV2 ? 'V2' : 'V3',
        brand,
      },
    });

    const { accessToken, refreshToken, refreshTokenExpiresIn: refreshExpiresIn } = data.login;

    setCookie('ION', 'refresh_Token', refreshToken, new Date().getTime() + 60 * 60 * 1000);
    await setTokenInCookies(accessToken, new Date().getTime() + 60 * 60 * 1000);
    const refreshTokenExpiresIn = refreshExpiresIn * 1000;
    const sessionExpiryTime = new Date(new Date().getTime() + refreshTokenExpiresIn).getTime();
    setCookie(
      'ION',
      'session',
      JSON.stringify({
        sessionExpiryTime,
        refreshTokenExpiresIn,
      })
    );
    setLocalStorageWithPrefix('ION_EXISTING_CUSTOMER', true);
  } catch (error) {
    console.error(error);

    if (error.message.includes('Invalid reCAPTCHA!')) {
      // setInvalidError(!invalidError);
      // setShowLoader(false);
      setDisablecta(true);
      setCaptchaV2Error(!captchaV2Error);
      setInvalidText('Invalid reCAPTCHA!');
    } else {
      setDisablecta(true);
    }
    recaptchaRef?.current?.reset();
  }
};
